import { PROPERTY_TYPE_EXPANSION_RULES } from '@app/consts/search-filters.consts';

/**
 * This function takes the user-selected property types and adds additional
 * property types based on business rules without modifying the original selection.
 */
export function applyPropertyTypeExpansion(selectedPropertyTypeIds: number[]): number[] {
    if (!selectedPropertyTypeIds || selectedPropertyTypeIds.length === 0) {
        return selectedPropertyTypeIds;
    }

    const expandedTypes = new Set(selectedPropertyTypeIds);

    for (const propertyTypeId of selectedPropertyTypeIds) {
        const expansionRule = PROPERTY_TYPE_EXPANSION_RULES.find(
            rule => rule.triggerId === propertyTypeId,
        );

        if (expansionRule?.additionalIds) {
            expansionRule.additionalIds.forEach(id => expandedTypes.add(id));
        }
    }

    return Array.from(expandedTypes);
}
